import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import { formatThousands } from "@/utils/index.js";
import PaymentConnect from "@/views/quarter/components/PaymentConnect.vue";
import ConfirmPopover from "./components/ConfirmPopover.vue";
import ConfirmOrder from "./components/ConfirmOrder.vue";
import RefundForm from "./components/RefundForm.vue";
import InvoiceForm from "./components/InvoiceForm.vue";
import SourceTag from "./components/SourceTag.vue";
import util from "@/libs/util";
import { mapActions } from "vuex";
export default {
  name: "paymentRecord",
  components: {
    PaymentConnect: PaymentConnect,
    ConfirmPopover: ConfirmPopover,
    ConfirmOrder: ConfirmOrder,
    RefundForm: RefundForm,
    InvoiceForm: InvoiceForm,
    SourceTag: SourceTag
  },
  computed: {
    //是财务角色
    isFinance: function isFinance() {
      var _this$adminList;
      var id = util.cookies.get("uuid");
      return (_this$adminList = this.adminList) === null || _this$adminList === void 0 ? void 0 : _this$adminList.find(function (item) {
        return item.id === id;
      });
    }
  },
  watch: {
    searchForm: {
      handler: function handler(nVal) {
        if (this.pageDB) {
          this.pageDB.set("searchFormPayment", this.searchForm).write();
        }
      },
      deep: true
    }
  },
  data: function data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 20,
        receiptWaterNbr: '',
        payer: '',
        payeeAccount: '',
        contractNo: '',
        companyId: '',
        companyName: '',
        status: ''
      },
      tableLoading: false,
      tableData: [],
      total: 0,
      payeeList: [{
        label: "上海良曜(支付宝)",
        value: "2021006100622710"
      }, {
        label: "上海良孝科技有限公司",
        value: "121945983810201"
      }, {
        label: "深圳良孝科技有限公司",
        value: "755974670210008"
      }, {
        label: "上海良曜科技有限公司",
        value: "121984461810001"
      }],
      loadingRefresh: false,
      waitNum: {},
      companyList: [],
      companyLoading: false,
      adminId: util.cookies.get("uuid") || "",
      adminList: [],
      //管理员列表
      applyInvoiceVisible: false,
      currentRow: {},
      applyInvoiceData: {
        invoiceType: '0',
        invoicingCompany: '',
        invoicingTaxNumber: ''
      }
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var data;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _this.databasePage({
              user: true
            });
          case 1:
            _this.pageDB = _context.v;
            _context.n = 2;
            return _this.pageDB.value();
          case 2:
            data = _context.v;
            if (data !== null && data !== void 0 && data.searchFormPayment) {
              _this.searchForm = _objectSpread(_objectSpread({}, data.searchFormPayment), {}, {
                pageNum: 1,
                pageSize: 20
              });
              if (_this.searchForm.companyId) {
                _this.getCompanyList(_this.searchForm.companyName);
              }
            }
            _this.$route.query.receiptWaterNbr && (_this.searchForm.receiptWaterNbr = _this.$route.query.receiptWaterNbr);
            _this.getData();
            _this.getAdminList();
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("d2admin/db", ["databasePage", "databasePageClear"])), {}, {
    formatThousands: formatThousands,
    selectCompany: function selectCompany(id) {
      var item = this.companyList.find(function (i) {
        return i.id === id;
      });
      this.searchForm.companyName = item ? item.companyName : '';
      this.getData('search');
    },
    getAdminList: function getAdminList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.getAdminUser({
                type: "finance"
              });
            case 1:
              res = _context2.v;
              _this2.adminList = res.data || [];
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    //获取未处理状态数量
    bankStatusTotal: function bankStatusTotal() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$api.bankStatusTotal();
            case 1:
              res = _context3.v;
              _this3.waitNum = res.data || {};
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    remoteMethod: function remoteMethod(query) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (query !== "") {
                _this4.getCompanyList(query);
              }
            case 1:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getCompanyList: function getCompanyList(query) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _res$data;
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _this5.companyLoading = true;
              _context5.n = 1;
              return _this5.$api.findAllBqCompanyinfo({
                companyName: query,
                pageNum: 1,
                pageSize: 20
              });
            case 1:
              res = _context5.v;
              _this5.companyLoading = false;
              _this5.companyList = ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.content) || [];
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    // 关联支付记录
    connect: function connect(row) {
      this.$refs.paymentConnect.show(row);
    },
    setDataSource: function setDataSource(type) {
      if (type === "CMB") {
        return "招商银行";
      } else if (type === "ALIPAY") {
        return "支付宝";
      }
      return "";
    },
    pageChange: function pageChange(current) {
      this.searchForm.pageNum = current;
      this.getData();
    },
    getData: function getData(type) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _this6.bankStatusTotal();
              if (type === "search") {
                _this6.searchForm.pageNum = 1;
                _this6.total = 0;
              }
              _this6.tableLoading = true;
              _context6.p = 1;
              _context6.n = 2;
              return _this6.$api.getPaymentRecord(_this6.searchForm);
            case 2:
              res = _context6.v;
              _this6.tableData = res.data.content || [];
              _this6.total = res.data.totalSize || 0;
            case 3:
              _context6.p = 3;
              _this6.tableLoading = false;
              return _context6.f(3);
            case 4:
              return _context6.a(2);
          }
        }, _callee6, null, [[1,, 3, 4]]);
      }))();
    },
    refreshOrigin: function refreshOrigin() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _this7.loadingRefresh = true;
              _context7.n = 1;
              return _this7.$api.syncPaymentRecord();
            case 1:
              res = _context7.v;
              if (res.code === 200) {
                _this7.$message.success("同步成功");
                _this7.getData();
              }
              _this7.loadingRefresh = false;
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    //剔除
    deleteRecord: function deleteRecord(callback, row) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var ok, _t;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return _this8.$api.bankEliminate(_this8.setParams(row));
            case 1:
              _t = _context8.v.code;
              ok = _t === 200;
              ok && _this8.$message.success("已剔除记录");
              callback(ok);
              _this8.$operationLog.push({
                code: 'delete',
                operationType: 'payment',
                detailBatchNo: row.receiptWaterNbr
              });
              _this8.getData();
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    //申请退款
    applyRefund: function applyRefund(callback, row) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var ok, _t2;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _context9.n = 1;
              return _this9.$api.bankApplyRefund(_this9.setParams(row));
            case 1:
              _t2 = _context9.v.code;
              ok = _t2 === 200;
              ok && _this9.$message.success("已申请退款");
              callback(ok);
              _this9.$operationLog.push({
                code: 'apply_refund',
                operationType: 'payment',
                detailBatchNo: row.receiptWaterNbr
              });
              _this9.getData();
            case 2:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    // 打开申请开票弹窗
    showApplyInvoice: function showApplyInvoice(row) {
      this.applyInvoiceData = {
        invoiceType: '0',
        invoicingCompany: row.invoicingCompany,
        invoicingTaxNumber: row.invoicingTaxNumber
      };
      this.currentRow = row;
      this.applyInvoiceVisible = true;
    },
    //申请开票
    applyInvoice: function applyInvoice() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var ok, _t3;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              _context0.n = 1;
              return _this0.$api.bankApplyInvoice(_objectSpread(_objectSpread({}, _this0.setParams(_this0.currentRow)), _this0.applyInvoiceData));
            case 1:
              _t3 = _context0.v.code;
              ok = _t3 === 200;
              ok && _this0.$message.success("已申请开票");
              // callback(ok);
              _this0.$operationLog.push({
                code: 'invoice',
                operationType: 'payment',
                detailBatchNo: _this0.currentRow.receiptWaterNbr
              });
              _this0.applyInvoiceVisible = false;
              _this0.getData();
            case 2:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    },
    //确认收款
    confirmPayment: function confirmPayment(callback, row) {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var ok, _t4;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              _context1.n = 1;
              return _this1.$api.bankConfirmProcess(_objectSpread(_objectSpread({}, _this1.setParams(row)), {}, {
                status: "4"
              }));
            case 1:
              _t4 = _context1.v.code;
              ok = _t4 === 200;
              ok && _this1.$message.success("已确认");
              _this1.$operationLog.push({
                code: 'confirm',
                operationType: 'payment',
                detailBatchNo: row.receiptWaterNbr
              });
              callback(ok);
              _this1.getData();
            case 2:
              return _context1.a(2);
          }
        }, _callee1);
      }))();
    },
    refundPayment: function refundPayment(callback, row) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var ok, _t5;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              _context10.n = 1;
              return _this10.$api.bankReject(_this10.setParams(row));
            case 1:
              _t5 = _context10.v.code;
              ok = _t5 === 200;
              ok && _this10.$message.success("已拒绝");
              callback(ok);
              _this10.$operationLog.push({
                code: 'refuse',
                operationType: 'payment',
                detailBatchNo: row.receiptWaterNbr
              });
              _this10.getData();
            case 2:
              return _context10.a(2);
          }
        }, _callee10);
      }))();
    },
    addRefund: function addRefund(row) {
      this.$refs.refundForm.show(row);
    },
    editRefund: function editRefund(row) {
      this.$refs.refundForm.show(row);
    },
    confirmInvoice: function confirmInvoice(row) {
      this.$refs.invoiceForm.show(row);
    },
    editInvoice: function editInvoice(row) {
      this.$refs.invoiceForm.show(row, true);
    },
    setParams: function setParams(row) {
      return {
        transactionNo: row.receiptWaterNbr,
        status: row.status,
        slip: row.slip,
        adminId: this.adminId
      };
    },
    //预览 pdf 文件
    previewPdf: function previewPdf(url) {
      window.open(url);
    }
  })
};